<template>


   <div class="div_box_transp" id="market">
      
      <h1></h1>
      
      <coingecko-coin-price-chart-widget currency="usd" coin-id="flappy-bird-evolution" locale="en"  width="100%" height="250"></coingecko-coin-price-chart-widget>
      
  </div>
  

  <br><br>
<div class="div_box">
  <div>
    <h1 id="stakev2">FEVO STAKE V2</h1>
    <br><br>
    <h3 align="justify">
      <table>
        <tr>
          <td valign="middle">
            <img src="../assets/fevogamewlapapper.png" alt="Imagem" width="320" height="260" style="margin-right: 20px;">
          </td>

          <td>
            <br><br>

            <p style="font-size: 18px; line-height: 1.6;">
              Flappy Bird Evolution Stake V2<br>
              With play to earn GAME PASS<br>
              All holders of FEVO Stake V2 have free access to our play-to-earn game!
            </p>

            <p style="font-size: 18px; line-height: 1.6;">
              Launch the app, connect your Metamask, and start earning.
            </p>

            <br><br>

            <a href="https://fevostakev2.web.app" class="button-47" target="_blank">Launch APP</a>
          </td>
        </tr>
      </table>
    </h3>
  </div>
</div>


  <br><br>
    <div class="div_box"  >
      
      <div >
        <h1 id="stake">FEVO STAKE (Deprecated)</h1>
        <br><br>
        <h3 align="justify">

          <table>
          <tr>
            <td valign="middle">
              <img src="../assets/logo.png" alt="Imagem" width="300" height="260">
            </td>
            
            <td >
              

                <br><br>  


              <p style="font-size: 18px; line-height: 1.6;">
                Stake your FEVO with a 32% APY, the minimum staking period is 90 days.
                </p>
                
                <p style="font-size: 18px; line-height: 1.6;">
                Launch the app, connect your Metamask, and start earning.
              </p>

              <br><br>
              
              <a href="https://app-flappybirdevolution.web.app/" class="button-47" target="_blank">Launch APP</a>
            </td>
          </tr>
     </table>


      </h3>
        
      </div>
      </div>


  <br><br>
    <div class="div_box"  >
      
      <div >
        <h1 id="burn">FEVO BURN</h1>
        <br><br>
        <h3 align="justify">

          <table>
          <tr>
            <td valign="middle">
              <img src="../assets/logo.png" alt="Imagem" width="300" height="260">
            </td>
            
            <td >
              

                <br><br>  


              <p style="font-size: 18px; line-height: 1.6;">
                Now you have the ability to burn FEVO tokens at your discretion. Just input the desired amount, confirm, and approve the burn.
                </p>
                
                <p style="font-size: 18px; line-height: 1.6;">
                We will do our part and gradually burn 20% of the total supply
              </p>

              <br><br>
              
              <input  class="form__input_text_big_2"  type="number" id="quantity" name="quantity" min="1" max="30000000000000" v-model="quantity" >
       
              <button margin-left="100px" class="button-35" @click="burn()" id="btn-burn">
                  BURN  <img style="width: 40px;" src="../assets/fire.png">
              </button>
            </td>
          </tr>
     </table>


      </h3>
        
      </div>
      </div>
  
  
  
  


    <br><br>
    <div class="div_box"  >
      
      <div >
        <h1 id="about">About Flappy Bird Evolution</h1>
        <br><br>
        <h3 align="justify">

          <table>
          <tr>
            <td valign="middle">
              <img src="../assets/logo.png" alt="Imagem" width="300" height="260">
            </td>
            <td>
              <p style="font-size: 20px; line-height: 1.6;">
                <strong>Hello everyone!</strong>
              </p>
              <p style="font-size: 18px; line-height: 1.6;">
                I'd like to introduce the groundbreaking project GAMEFi $FEVO - Flappy Bird Evolution, inspired by the iconic game Flappy Bird. In this project, we are combining thrilling game elements with blockchain technology, providing a unique and innovative gaming experience.
              </p>

              <p style="font-size: 18px; line-height: 1.6;">
                <strong>$FEVO is a blockchain-based game</strong> that allows players to own, collect, and trade exclusive characters within the game's ecosystem. Through the use of smart contracts, we ensure that each character is truly owned by the player, providing an authentic digital asset economy.
              </p>

              <p style="font-size: 18px; line-height: 1.6;">
                In the game, you can train your characters to become the best flyers, compete with other players in thrilling races, and take on exciting challenges. As your characters evolve and improve their skills, new opportunities and rewards arise, making the gaming journey even more rewarding.
              </p>

              <p style="font-size: 18px; line-height: 1.6;">
                Moreover, <strong>$FEVO also features a virtual marketplace</strong> where players can buy, sell, and trade their unique characters, enabling you to earn real value through your passion for gaming.
              </p>

              <p style="font-size: 18px; line-height: 1.6;">
                Not only that, but <strong>the project is also committed to transparency, security, and decentralization</strong>, ensuring that each player has full control over their digital assets and interactions within the ecosystem.
              </p>

              <p style="font-size: 20px; line-height: 1.6;">
                <strong>Join us in the thrilling universe of $FEVO - Flappy Bird Evolution and experience a new era of blockchain gaming with endless possibilities and fun.
                </strong>
              </p>
            </td>
          </tr>
     </table>


      </h3>
        
      </div>
      </div>



     



        <br><br>
    <div class="div_box" >
    
      <div >
        <h1 id="FEVO">FEVO Token</h1>
        <br><br>
        <h3 align="justify">
          <table>
          <tr>
            <td valign="middle">
          <img src="../assets/polygon_fevo.png" alt="Discord Icon" width="300" height="260" style="float: left; margin-right: 20px;">
          
        </td>
            <td>
              <p style="font-size: 18px; line-height: 1.6;">
              <strong>Unlocking the Potential of the FEVO Token: More Than Just a Gaming Coin</strong>
              </p>

              <p style="font-size: 18px; line-height: 1.6;">
                  Welcome to the exciting $FEVO ecosystem, where our native token, FEVO, plays a central role in a variety of functions far beyond being just a simple gaming currency. Let's explore how FEVO is a fundamental piece in our community:
              </p>

              <p style="font-size: 18px; line-height: 1.6;"><strong>1. Purchasing Exclusive NFTs:</strong></p>
              <ul style="font-size: 18px; line-height: 1.6;">
                  <li>FEVO is the key to unlocking a world of unique NFTs within the $FEVO ecosystem. With it, players can acquire characters, skins, and other digital assets that make the gaming experience truly one-of-a-kind.</li>
              </ul>

              <p style="font-size: 18px; line-height: 1.6;"><strong>2. In-Game Rewards:</strong></p>
              <ul style="font-size: 18px; line-height: 1.6;">
                  <li>Playing and winning in the world of $FEVO means being rewarded with FEVO. The more you engage and progress in the game, the more FEVO you can earn. These rewards can be used to enhance your characters, acquire valuable NFTs, and much more.</li>
              </ul>

              <p style="font-size: 18px; line-height: 1.6;"><strong>3. Staking and Passive Earnings:</strong></p>
              <ul style="font-size: 18px; line-height: 1.6;">
                  <li>FEVO also opens up opportunities for staking, allowing holders to earn additional passive rewards. You can leverage your FEVO to contribute to the security and operation of the network while earning more tokens in return.</li>
              </ul>

              <p style="font-size: 18px; line-height: 1.6;"><strong>4. NFT Rentals:</strong></p>
              <ul style="font-size: 18px; line-height: 1.6;">
                  <li>Furthermore, our ecosystem offers a unique option for NFT rentals. With FEVO, you can rent NFTs from other players or make your own NFTs available for rent, generating passive income from your valuable digital collections.</li>
              </ul>

              <p style="font-size: 18px; line-height: 1.6;"><strong>5. Governance Participation:</strong></p>
              <ul style="font-size: 18px; line-height: 1.6;">
                  <li>The $FEVO community is paramount, and the FEVO token grants the right to actively participate in governance. Holders can vote on proposals that influence the project's development and direction, making all players part of the decision-making process.</li>
              </ul>

              <p style="font-size: 18px; line-height: 1.6;">
                  In summary, the FEVO token is much more than just a gaming coin. It is the backbone of the $FEVO ecosystem, enabling the acquisition of unique NFTs, rewarding players, boosting staking, allowing NFT rentals, and granting governance power to the community. Get ready to unlock the full potential of this token as you venture into the exciting universe of $FEVO. The future of gaming and decentralized finance is in your hands!
              </p>
              </td>
              </tr>
              </table>
          </h3>
        </div>
      </div>    


  <br><br><br>
  
  <div  class="div_box" >
    <h1 id="exchanges">Trade $FEVO</h1>  
    <div style="float:left; width:100%; ">    
      <br><br>
      <h3 align="justify">
      
        <p style="font-size: 26px; line-height: 1.6;">You can now trade <span style="font-weight: bold;">$FEVO</span>  on the following Exchanges:</p>
        <br><br>
        <table>
          <tr>
            
            <td valign="middle">
              <img src="https://algorex.net/assets/algorx-BNvsNT_0.png" alt="AlgorEx Exchange" width="300" height="260" style="float: left; margin-right: 20px;">
            </td><td>
              <p style="font-size: 18px; line-height: 1.6;">
              Trade FEVO in AlgorEx Exchange.
            </p>           
            <ul>
              <li><a href="https://algorex.net/trade/FEVO-USDT" style="color: #5865F2;" target="_blank">FEVO/USDT</a></li>
            </ul>

            </td>  
            
           </tr>
           <br><br><br>
           <tr>
            
            <td valign="middle">
              <img src="../assets/nonkyclogoicon.png" alt="Discord Icon" width="300" height="260" style="float: left; margin-right: 20px;">
            </td><td>
              <p style="font-size: 18px; line-height: 1.6;">
              Trade FEVO in NonKYC Exchange.
            </p>           
            <ul>
              <li><a href="https://nonkyc.io/market/FEVO_USDT" style="color: #5865F2;" target="_blank">FEVO/USDT</a></li>
              <li><a href="https://nonkyc.io/market/FEVO_USDC" style="color: #5865F2;" target="_blank">FEVO/USDC</a></li>
              <li><a href="https://nonkyc.io/market/FEVO_BNB" style="color: #5865F2;" target="_blank">FEVO/BNB</a></li>
              <li><a href="https://nonkyc.io/market/FEVO_BTC" style="color: #5865F2;" target="_blank">FEVO/BTC</a></li>
            </ul>

            </td>  
            
           </tr>
           <br><br><br>

         
            </table>



    </h3>
     
    </div>
  </div>
  
  <br><br><br>
  
  <div  class="div_box" >
    <h1 id="faucet">Giveaway $FEVO</h1>
    <div style="float:left; width:100%; ">    
      <br><br>
      <h3 align="justify">
      
        <table>
          <tr>
            <td valign="middle">
              <img src="../assets/logo.png" alt="Discord Icon" width="300" height="260" style="float: left; margin-right: 20px;">
            </td>
            <td>
              <p style="font-size: 18px; line-height: 1.6;">
            <strong>Join our $FEVO Faucet Giveaway!</strong>
              </p>

              <p style="font-size: 18px; line-height: 1.6;">
                  We are giving away FEVO for free as part of this special promotion. 
                  Visit <a style="color: #5865F2;" href="https://xeggex.com/faucet" target="_blank">https://xeggex.com/faucet</a> and claim your coins now.
              </p>

              <p style="font-size: 18px; line-height: 1.6;">
                  <strong>Don't miss out on this opportunity!</strong>
              </p>
           </td>
           </tr>
            </table>



    </h3>
     
    </div>
  </div>

  <br><br><br>   

  <br><br><h1>  </h1>
    <div class="div_box" id="wallet">
      <h3 align="justify">
        <center>
        <h1 id="faucet">Metamask</h1>
      </center>
      <table>
          <tr>
            <td valign="middle">
              <img src="../assets/mm.png" alt="Discord Icon" width="280" height="240" style="float: left; margin-right: 20px;">
            </td>
            <td>
      <br><br>
      <h3>FEVO Token is a platform that enables users to dive into the next generation of blockchain games. To facilitate transactions, the platform supports the Metamask wallet. Add the wallet by clicking on the corresponding button and start taking advantage of FEVO Token.
        </h3>
          <br>
        
          <button class="button-36" @click="addTokenInWallet">
          Add FEVO in Metamask  <img style="width: 50px;" src="../assets/mm.png">
          </button>
        
      </td>
      </tr>
      </table>
    </h3>
    </div>

  <br><br><br>   
  
  <div  class="div_box" style="word-wrap: break-word;" >
    <h1 id="whitepaper">White paper</h1>
    <h3 align="justify">
      <br><br><br>
    

          <br>
          <table>
          
            <tr>
            <td valign="middle">
              <img src="../assets/polygon.png" alt="Polygon Icon" width="280" height="240" style="float: left; margin-right: 20px;">
            </td>
            <td>


            <p style="font-size: 20px; line-height: 1.6;">
                <strong>BLOCKCHAIN NFT GAME</strong>
            </p>
            <br>
            <p style="font-size: 18px; line-height: 1.6;">
                Flappy bird evolution is a The classic bird game is now blockchain game, Flappy bird evolution is P2E, F2P and NFT game.
            </p>

            <p style="font-size: 18px; line-height: 1.6;">
                We will have different stages, characters, player incentives, rewards and much more.
            </p>

            <p style="font-size: 18px; line-height: 1.6;">
                We want to be a fun game to play and also profitable. The first to enter will have bigger rewards and over time it will gradually decrease as the tokens are burned and their monetary value increases.
            </p>

            <p style="font-size: 18px; line-height: 1.6;">
                You can play for free or use your NFT characters to earn even more.
            </p>

            <p style="font-size: 18px; line-height: 1.6;">
                In free mode, each point made in the game is converted to FEVO token. Using the game's NFT's the gains are even greater.
            </p>

            <p style="font-size: 18px; line-height: 1.6;">
                FEVO is the native token of the game, created on the Polygon network, and it is used as in-game rewards and to buy character NFTs, NFTs are only sold in FEVO/NFT's pair.
            </p>

            <p style="font-size: 18px; line-height: 1.6;">
                The total Supply is 100 trillion FEVO, and every FEVO token earned in the game the same amount is burned monthly.
            </p>

            <p style="font-size: 18px; line-height: 1.6;">
                There will be big burns as users join the game.
            </p>
            <br><br>
            <p style="font-size: 18px; line-height: 1.6;">
                <strong>Tokenomics:</strong>
            </p>

            <p style="font-size: 18px; line-height: 1.6;">
                <strong>Name:</strong> Flappy bird evolution<br>
                <strong>Symbol:</strong> FEVO<br>
                <strong>Network:</strong> Polygon<br>
                <strong>Total supply:</strong> 100 tri<br>
                <strong>Max supply:</strong> 100 tri<br>
                <strong>Contract address:</strong> 
                <a style="color: #5865F2;" href="https://polygonscan.com/token/0xAa1e97614Eaf8D85DBf58F7F0b3080B2AffCfEfc" target="_blank">
                  <p style="font-size: 12px; line-height: 1.6;">0xAa1e97614Eaf8D85DBf58F7F0b3080B2AffCfEfc</p></a><br>
                <strong>Block Scan:</strong> <a style="color: #5865F2;" href="https://polygonscan.com/token/0xAa1e97614Eaf8D85DBf58F7F0b3080B2AffCfEfc" target="_blank"><p>Go to Polygonscan</p></a>
            </p>
            <br><br>
            <p> FEVO Token distribution:</p>
              <p> - Development Reserve: 15%</p>
              <p> - Partnerships/Listings: 10%</p>
              <p> - Liquidity Reserve: 10%</p>
              <p> - Player Rewards: 30%</p>
              <p> - Burns: 20%</p>
              <p> - Staking Rewards: 15%</p>

              
              
            </td>
            </tr>
            </table>

      </h3>
     
    </div>
  

    

    <div class="div_box" >
      <h1 id="discord">Join our Discord!</h1>

      <div align="justify">
        
        <br>
        <h3 >
          <table>
          <tr>
            <td valign="middle">
              <img src="../assets/discord.png" alt="Discord Icon" width="280" height="240" style="float: left; margin-right: 20px;">
            </td>
            <br><br><br>
            Join our Flappy Bird Evolution Discord community today and flap your way to victory!

          <p>
            Click the link below to join our Discord server:
          </p>

          <p>
            <a href="https://discord.gg/99MEJRRXrj" style="color: #5865F2;">Join Flappy Bird Evolution Discord</a>

          </p>

            <td>
              </td>
              </tr>
              </table>

            
  

           
          </h3>
        </div>
      </div>    

 
      <br><br>
        

    <div class="div_box" >
      <h1 id="playgame">Play Flappy Bird Evolution GAME</h1>

      <div align="justify">
        
        <br>
        <h3 >
          <table>
          <tr>
            <td valign="middle">
              <img src="../assets/fevogamewlapapper.png" alt="Play Flappy Bird Evolution GAME" width="300" height="260" style="float: left; margin-right: 20px;">
            </td>

            <td>
              



                    <p style="font-size: 18px; line-height: 1.6;">
                    <strong>🚀 We are launching Flappy Bird Evolution in BETA phase! 🎮</strong>
                </p>

                <p style="font-size: 18px; line-height: 1.6;">
                  All $FEVO holders in Stake V2 have free access to the game and can start earning exclusive rewards! 🏆
                </p>

                <p style="font-size: 18px; line-height: 1.6;">
                Click the button below to play now! ⬇️
              </p>
              <a href="/fevogame" class="button-47" target="_blank">Play now!</a>
              </td>
              </tr>
              </table>

            
  

           
          </h3>
        </div>
      </div>    


  <div class="div_box_twitter">
    <div id="twitter">
    
    <br><br>
    <br><br>
    <h1>Tweets</h1>
    <br><br>
    <a href="https://twitter.com/flapbirdevo?ref_src=twsrc%5Etfw" class="twitter-follow-button" data-show-count="false">Follow @flapbirdevo</a>
    <br><br>
</div>
      
      <a class="twitter-timeline" style="color: #5865F2;" href="https://twitter.com/flapbirdevo?ref_src=twsrc%5Etfw">Tweets by Flappy Bird Evolution</a>
    
  </div>
  
</template>

<script>
import { ethers } from "ethers";




export default {
  mounted() {
    const plugin = document.createElement("script");
    plugin.setAttribute(
      "src",
      "https://platform.twitter.com/widgets.js"
    );
    plugin.async = true;
    document.head.appendChild(plugin);



    const plugin2 = document.createElement("script");
    plugin2.setAttribute(
      "src",
      "https://widgets.coingecko.com/coingecko-coin-price-chart-widget.js"
    );
    plugin2.async = true;
    document.head.appendChild(plugin2);

   
  },
  name: 'App',
  data() {
      return {
        userAddress: '',
        fevoBalance: '',
        quantity: '',

      }
    }
        ,methods:{
          getTokenBalance(){
              const ethers = require('ethers')

              
              // The Contract interface
              let abi = [
                "function totalSupply() external view returns (uint256)",
                "function balanceOf(address account) external view returns (uint256)",
                "function allowance(address owner, address spender) external view returns (uint256)",
                "function transfer(address recipient, uint256 amount) external returns (bool)",
                "function approve(address spender, uint256 amount) external returns (bool)",
                "function transferFrom(address sender, address recipient, uint256 amount) external returns (bool)",
                "event Transfer(address indexed from, address indexed to, uint256 value)",
                "event Approval(address indexed owner, address indexed spender, uint256 value)"
              ]

              // Connect to the network
              //let provider = ethers.getDefaultProvider()
              //let provider = ethers.getDefaultProvider("https://rpc.ankr.com/bsc_testnet_chapel") // testnet
              let provider = ethers.getDefaultProvider("https://rpc.ankr.com/polygon") // production

              // The address from the above deployment example
              let contractAddress = "0xAa1e97614Eaf8D85DBf58F7F0b3080B2AffCfEfc" // production
              //let contractAddress = "0xC3672F25C5dA3ac3E752d0A9804BA7495A99Deba" // testnet

              // We connect to the Contract using a Provider, so we will only
              // have read-only access to the Contract
              let contract = new ethers.Contract(contractAddress, abi, provider)

    
                
            console.log("UserAddress:" + this.userAddress[0]) ;

            contract.balanceOf(this.userAddress[0]).then(balance => {
                  // Return string value to convert it into int balance
                  console.log("$FEVO balance: " + ethers.utils.formatEther(balance)) ;
                  this.fevoBalance = ethers.utils.formatEther(balance);
                  
                })

          },burn(){
                    
                      
              let    abi = [{
                      "inputs": [
                        {
                          "internalType": "uint256",
                          "name": "amount",
                          "type": "uint256"
                        }
                      ],
                      "name": "burn",
                      "outputs": [],
                      "stateMutability": "nonpayable",
                      "type": "function"
                    }]

                    const contractAddress = "0xAa1e97614Eaf8D85DBf58F7F0b3080B2AffCfEfc";
                    let qtdBurn = ethers.utils.parseEther(this.quantity +'');

                    console.log("Get provider");
                      const provider = new ethers.providers.Web3Provider(window.ethereum)

                      console.log("userAddress: " + this.userAddress[1]);
                      const signer = provider.getSigner(this.userAddress[1]);

                      console.log("Get contract");
                    
                    // const contract = new ethers.Contract(contractAddress, abi, signer);
                    const contract = new ethers.Contract(contractAddress, abi, provider);

                    const daiWithSigner = contract.connect(signer);
                    
                    if (confirm('Do you really want to burn ' + this.quantity + ' FEVO?')) {
                      // Save it!
                      daiWithSigner.burn(qtdBurn).then( ret => {
                        // Return string value to convert it into int balance
                        console.log("$Buy ret: " + JSON.stringify(ret) ) ;

                        
                        try{
                          console.log(ret.hash);
                          alert('You can see this transaction in Polygon Scan by the link below, https://polygonscan.com/tx/'+ret.hash+'  ');
                          
                        }catch (error){
                          console.log(error);
                        }
                        
                      });
                    } else {
                      // Do nothing!
                      console.log('Thing was not saved to the database.');
                    }
                  
                      
    },
          addTokenInWallet: function(){


          try {
            const params = {
            type: 'ERC20',
            options: {
              address: '0xAa1e97614Eaf8D85DBf58F7F0b3080B2AffCfEfc',
              symbol: 'FEVO',
              decimals: 18,
              image: 'https://flappybirdevolution.web.app/img/logo.913a3c98.png'
            }
          }

          window.ethereum.request({ method: 'wallet_watchAsset', params })
            .then(() => console.log('Success, Token added!'))
            .catch((error) => console.log('Error: '+ error.message))


          } catch (error) {
            console.log(error);
          }
        }
    },
  props: {
    msg: String
  }
        ,beforeMount() {

                if(window.ethereum){
                // Do something 
                //alert("Metamask extension OK!!")
                }else{
                  alert("Go to PC and install metamask extension!!")
                }

                window.ethereum.request({method:'eth_requestAccounts'})
                .then(res=>{
                      // Return the address of the wallet
                      console.log("Address:" + res) ;
                      this.userAddress = res;
                      this.getTokenBalance();
                      

                })
          }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}


.form__label {
  font-family: 'Roboto', sans-serif;
  font-size: 1.5rem;
  margin-left: 2rem;
  margin-top: 0.7rem;
  display: block;
  transition: all 0.3s;
  transform: translateY(0rem);
}

.form__input {
  font-family: 'Roboto', sans-serif;
  color: rgb(85, 85, 204);
  font-size: 1.8rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 20%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}



.form__input:placeholder-shown + .form__label {
  opacity: 0;
  visibility: hidden;
  -webkit-transform: translateY(-4rem);
  transform: translateY(-4rem);
}

*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
  font-size: 62,5%;
}
.font_12{
  font-size: 1.2em;
    font-family: sans-serif;
}
.font_10{
  font-size: 1.0em;
    font-family: sans-serif;
}


.box {
  width: 100%;
  height: 30%;
  background-color: white;
}


.div_box {
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  border-color:rgba(185, 185, 193, 0.5);
  background-color:rgba(30, 30, 31, 0.5);
  border: 0.00rem;
  width: 80%;
  
  margin-top: 30px;
  display: inline-table;
  font-size: 17px;
  font-family: 'Courier New', Courier, monospace;
  transition: all 0.3s;
  text-align: center;
  border-style: solid;
}


.div_box_transp {
	margin:  auto;
  padding: 0.0rem 0rem;
  border-radius: 0.0rem;
  border-color:transparent;
  background-color:transparent;
  border: 0.00rem;
  width: 85%;
  
  margin-top: 0px;
  display: inline-table;
  font-size: 17px;
  font-family: 'Courier New', Courier, monospace;
  transition: all 0.3s;
  text-align: center;
  border-style: solid;
}






.subdiv_box {
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  border-color:rgba(185, 185, 193, 0.5);
  border: 0.05rem;
  width: 100%;
  margin: 20px;
  margin-top: 30px;
  display: inline-table;
  display: inline-table;
  font-size: 17px;
  transition: all 0.3s;
  text-align: center;
  border-style: solid;
}


.div_box_twitter {
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  border-color:rgba(185, 185, 193, 0.5);
  background-color:rgba(30, 30, 31, 0.5);
  border: 0.00rem;
  width: 80%;
  height: 400px;
  margin-top: 30px;
  display: inline-table;
  display: inline-table;
  font-size: 17px;
  transition: all 0.3s;
  text-align: center;
  border-style: solid;
}


.form__label {
  font-family: 'Roboto', sans-serif;
  font-size: 1.2rem;
  margin-left: 2rem;
  margin-top: 0.7rem;
  display: block;
  transition: all 0.3s;
  transform: translateY(0rem);
}




.button-42 {
  background-color: initial;
  background-image: linear-gradient(-180deg, #FF7E31, #E62C03);
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-block;
  font-family: Inter,-apple-system,system-ui,Roboto,"Helvetica Neue",Arial,sans-serif;
  height: 40px;
  line-height: 40px;
  outline: 0;
  overflow: hidden;
  padding: 0 20px;
  pointer-events: auto;
  position: relative;
  text-align: center;
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: top;
  white-space: nowrap;
  width: 100px;
  z-index: 9;
  border: 0;
  transition: box-shadow .2s;
}

.button-42:hover {
  box-shadow: rgba(253, 76, 0, 0.5) 0 3px 8px;
}

html {
  scroll-behavior: smooth;
  
}


    body {
      font-family: 'Quicksand', sans-serif;
      line-height: 1.6;
    }
    p {
      font-size: 16px;
    }
    strong {
      font-weight: 700;
    }
    em {
      font-style: italic;
    }
    ul {
      list-style: disc;
      margin-left: 20px;
      font-size: 16px;
    }
    li {
      margin-bottom: 10px;
    }
    span.highlight {
      color: #007bff;
      font-weight: bold;
    }
    span.subtitle {
      font-size: 1.1rem;
      color: #a71688;
      font-weight: 700;
    }
    .form__input_text_big_2 {
  font-family: 'Roboto', sans-serif;
  color: rgb(85, 85, 204);
  font-size: 2.2rem;
	margin:  auto;
  padding: 0.5rem 0.5rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 40%;
  
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}
  
.button-35 {
  background-image: linear-gradient(92.88deg, #c9a831 9.16%, #981e2e 43.89%, #c9a831 64.72%);
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  flex-shrink: 0;
  font-family: "Inter UI","SF Pro Display",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Open Sans","Helvetica Neue",sans-serif;
  font-size: 16px;
  font-weight: 500;
  height: 4rem;
  padding: 0 1.6rem;
  text-align: center;
  text-shadow: rgba(0, 0, 0, 0.25) 0 3px 8px;
  transition: all .5s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  display: inline-flex;
  align-items: center; 
}

@media only screen and (max-width: 600px) {
    table {
        display: block;
    }

    table tr {
        display: block;
    }

    table td {
        display: block;
    }

    table td:first-child {
        text-align: center;
        margin-bottom: 20px;
    }

    table td:last-child {
        text-align: center;
    }
}

.button-47 {
  background-color: initial;
  background-image: linear-gradient(-180deg, #570b64, #905d99);
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-block;
  font-family: Inter,-apple-system,system-ui,Roboto,"Helvetica Neue",Arial,sans-serif;
  height: 40px;
  line-height: 40px;
  outline: 0;
  overflow: hidden;
  
  margin-left: 10px;
  pointer-events: auto;
  position: relative;
  text-align: center;
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: top;
  white-space: nowrap;
  width: 200px;
  z-index: 9;
  border: 0;
  transition: box-shadow .2s;
  text-decoration:none;
  display: inline-block; 
  justify-content: flex-end;
}

.button-47:hover {
  box-shadow: rgba(113, 197, 208, 0.9) 0 6px 10px;
}

</style>

